<app-all-meetings-list
  [disableBreadcrumb]="true" [disableFilters]="false" [typeKey]="[MEETING_TYPE_EXAM, MEETING_TYPE_ENTRANCE_EXAM]" [tableFor]="'Egzamin'"
  [embeddedView]="true"
  [dialogView]="true"
  [displayedColumns]="['meeting', 'logo', 'insuranceCompany', 'startsAt',
    'status', 'examType', 'place', 'linkOrAddress', 'limitOfPeople', 'select']"
  (selectedMeeting)="selectedMeeting($event)"
  [statusKey]="MEETING_STATUS_DURING_REGISTRATIONS"
  [insuranceCompany]="insuranceCompanyId"
  [missingExamKeys]="missingExamKeys"
></app-all-meetings-list>
